import React from 'react'

function AlertPage() {
  return (
    <div>
      <h1>알림 페이지 (모바일)</h1>
    </div>
  )
}

export default AlertPage
